<template>
    <div>
        <form @submit.prevent="select">
            <div class="form-group">
                <label for="document-type">Scegli il tipo di documento</label>
                <select id="document-type" class="form-control" v-model="document">
                    <option v-for="document in documents" :value="document" :key="document.id">{{ document.name }}</option>
                </select>
            </div>

            <div class="text-center">
                <button class="btn btn-primary" type="submit">Scegli</button>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    name: 'select-document-type-form',
    props: {
        documents: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            document: null,
        };
    },
    methods: {
        select() {
            this.$emit('selected', this.document);
        },
    },
};

</script>
